import { styled } from '@mui/material'
import React from 'react'

export const AppBarOffset: React.FC = () => {
  const Offset = styled('div')(({ theme }) => theme.mixins.toolbar)
  return <Offset id="app-bar-offset" sx={{ marginY: 1 }} />
}
